import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from "@material-ui/core";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

import { CREATE_SHIP_BOX } from './shipbox_gql';
import moment from 'moment';

export default function NewShipBoxDialog(props) {
  const BLANK_SHIP_BOX = {
    shipName: "",
    shipDate: moment().format("YYYY-MM-DD"),
    shipExtra: "",
    eanList: ""
  }

  const [newShipBox, setNewShipBox] = useState(BLANK_SHIP_BOX);
  const [errors, setErrors] = useState({});
  const createShipBox = useMutation(CREATE_SHIP_BOX, {
    refetchQueries: [
      'GetShipBoxList'
    ],
    onError: (error) => {
      console.log(error);
    },
    onCompleted: (data) => {
      resetForm();
    }
  })[0];

  const handleUpdate = (field) => (
    (e) => setNewShipBox({ ...newShipBox, [field]: e.target.value })
  );

  const resetForm = () => {
    props.setCreatingBox(false);
    setNewShipBox(BLANK_SHIP_BOX);
    setErrors({});
  }

  const handleSubmit = () => {
    const newErrors = {};

    if (newShipBox.shipName === "") {
      newErrors.shipName = "can't be blank"
    }
    if (!newShipBox.shipDate) {
      newErrors.shipDate = "can't be blank"
    }
    if (newShipBox.eanList === "") {
      newErrors.eanList = "can't be blank"
    }

    setErrors(newErrors);

    if(Object.keys(newErrors).length === 0) {
      createShipBox({
        variables: {
          shipBoxIn: {
            shipName: newShipBox.shipName,
            shipDate: newShipBox.shipDate,
            shipExtra: newShipBox.shipExtra,
            eanList: newShipBox.eanList
          }
        }
      });
    }
  }

  return (
    <Dialog open={props.creatingBox} onClose={resetForm}>
      <DialogTitle>Create New Ship Box</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl>
              <InputLabel>Name</InputLabel>
              <Select id="name"
                label="Name"
                value={newShipBox.shipName}
                onChange={handleUpdate("shipName")}
                error={errors.shipName}
                >
                <MenuItem value="bhu">bhu</MenuItem>
                <MenuItem value="potm">potm</MenuItem>
                <MenuItem value="jira">jira</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <TextField id="date" type="date" label="Date" error={errors.shipDate} helperText={errors.shipDate} value={newShipBox.shipDate} onChange={handleUpdate("shipDate")} /><br />
          </Grid>
          <Grid item xs={12}>
            <TextField id="extra" label="Extra" value={newShipBox.shipExtra} helperText={errors.shipExtra} onChange={handleUpdate("shipExtra")} /><br />
          </Grid>
          <Grid item xs={6}>
            <TextField id="ean-list" label="EAN List" error={errors.eanList} value={newShipBox.eanList} helperText={errors.eanList} multiline onChange={handleUpdate("eanList")} /><br />
          </Grid>
          <Grid item xs={6}>
            <DialogContentText>
              Note: This system does not verify EANs. Please verify them before entering them here.
            </DialogContentText>
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" onClick={handleSubmit}>Submit</Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
